import { z } from "zod";

import { AvailableSubscriptionDiscountTypeList } from "../../../../../dtos/subscriptions";
import { castToNumber } from "../../../../../utils";

export * from "./variants";

export const TestGroupPricesDtoSchema = z.object({
  id: z.string(),
  name: z.string(),
  testGroupId: z.string().uuid().nullish(),
  price: castToNumber.or(z.string()),
  compareAtPrice: castToNumber.or(z.string()).nullish(),
  subscriptionDiscount: castToNumber.or(z.string()).nullish(),
  subscriptionDiscountType: z
    .enum(AvailableSubscriptionDiscountTypeList)
    .nullish(),
});

export const ProductVariantDtoSchema = z.object({
  id: z.string(),
  title: z.string().optional(),
  testGroupPrices: TestGroupPricesDtoSchema.array().default([]),
});
export type ProductVariantDto = z.infer<typeof ProductVariantDtoSchema>;

export const TestProductDtoSchema = z.object({
  id: z.string(),
  title: z.string().nullish().optional(),
  variants: ProductVariantDtoSchema.array(),
  handle: z.string().nullish().optional(),
  altHandles: z.record(z.string()).nullish().optional(),
  altIds: z.record(z.string()).nullish().optional(),
  image: z.string().nullish(),
  requiresSellingPlan: z.boolean().optional(),
});

export const PluginProductConfigSchema_2023_08_20 = TestProductDtoSchema.extend(
  {
    variants: ProductVariantDtoSchema.array(),
    title: z.string().nullable().optional(),
  }
);

export type PluginProductConfigType_2023_08_20 = z.infer<
  typeof PluginProductConfigSchema_2023_08_20
>;
